import { AnalyticIdentifier } from '@common/neo.tax';

import {
  AuthType,
  Path,
  getForwardedAuthParams,
  getPath,
  useAnalyticId,
  withForwardedAuthParams,
} from '@neo.tax/shared';

import { StyledEnterpriseSsoSwitch } from '../auth-form-header/auth-form-header.styled';
import { SsoButtons } from './SsoButtons';

interface SsoButtonsSectionProps {
  authType: AuthType;
}

export const SsoButtonsSection = ({ authType }: SsoButtonsSectionProps): React.ReactElement => {
  const continueWithSsoLinkId = useAnalyticId(AnalyticIdentifier.RTC_CONTINUE_WITH_SSO_LINK);

  // Forward invite/continue params to /enterprise-sso so the SAML/OIDC sign-in lands on
  // /accept-invitation afterward. Google/Microsoft work without this because their OAuth
  // dance never navigates away from /signup; SAML/OIDC requires a separate route.
  const enterpriseSsoHref = withForwardedAuthParams(getPath({ path: Path.ENTERPRISE_SSO }), getForwardedAuthParams());

  return (
    <>
      <SsoButtons authType={authType} />
      <StyledEnterpriseSsoSwitch id={continueWithSsoLinkId} to={enterpriseSsoHref}>
        Continue with OIDC/SAML
      </StyledEnterpriseSsoSwitch>
    </>
  );
};
